import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const join = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer = StrictEqualityComparer) => {
    const generator = async () => {
        const [innerArray, outerArray] = await Promise.all([inner.toArray(), outer.toArray()]);
        const results = new Array();
        for (const o of outerArray) {
            const outerKey = outerKeySelector(o);
            for (const i of innerArray) {
                const innerKey = innerKeySelector(i);
                if (comparer(outerKey, innerKey) === true) {
                    results.push(resultSelector(o, i));
                }
            }
        }
        return results;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
